export class DataStorage {
  private _storage: { [key: string]: any } = {};

  get<T>(key: string, defaultValue: T): T {
    if (!this.hasValue(key))
      return defaultValue;

    const value = this._storage[key];
    if (typeof (value) !== "object")
      return value as T;

    return (Array.isArray(value) ? [...value] : { ...value }) as T;
  }

  set(key: string, value: any): void {
    this._storage[key] = value;
  }

  hasValue(key: string): boolean {
    return this._storage[key] !== undefined;
  }
}